<template>
  <div class="star-condition-container">
    <div class="star-conditions" @keypress.enter="onSearch">
      <slot></slot>
    </div>
    <div class="actions">
<!--      <a-button type="link" v-if="childrenNumber > 4" @click="toggleIsConditionOpen">-->
<!--        <span>{{ isConditionOpen ? '收起' : '展开' }}</span>-->
<!--        <a-icon :type="isConditionOpen ? 'up' : 'down'" />-->
<!--      </a-button>-->
      <a-button @click="onReset">重置</a-button>
      <a-button type="primary" :loading="loading" @click="onSearch">查询</a-button>
    </div>
  </div>
</template>


<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    onSearch: {
      type: Function,
      default: () => {}
    },
    onReset: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      childrenNumber: 0,
      children: [],
      isConditionOpen: true
    }
  },
  provide() {
    return {
      addChild: ({ hide, show, id }) => {
        this.childrenNumber++
        if (!this.isConditionOpen && this.childrenNumber > 4) {
          hide()
        }
        this.children.push({ hide, show, id })
      },

      removeChild: (id) => {
        this.children = this.children.filter((child) => child.id !== id)
        this.childrenNumber--

        if (!this.isConditionOpen) {
          this.children.slice(0, 4).forEach((child) => {
            child.show()
          })
        }
      }
    }
  },
  methods: {
    // toggleIsConditionOpen() {
    //   if (this.isConditionOpen) {
    //     this.hide()
    //   } else {
    //     this.open()
    //   }
    // },
    //
    // open() {
    //   this.isConditionOpen = true
    //   this.children.forEach((child) => child.show())
    // },
    // hide() {
    //   this.isConditionOpen = false
    //   this.children.forEach((child, index) => {
    //     if (index > 3) {
    //       child.hide()
    //     }
    //   })
    // }
  }
}
</script>


<style lang="less" scoped>
.star-condition-container {
  width: 100%;
  padding: 16px 16px 6px 16px;
  background: white;
  display: flex;
  align-items: flex-start;

  .star-conditions {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
  }

  .actions {
    flex-shrink: 0;
    width: 220px;
    display: flex;
    flex-direction: row-reverse;
    gap: 8px;
  }
}
</style>
